import { FC } from 'react';
import LoadingSpinner from '../Button/LoadingSpinner/LoadingSpinner';
import styles from './FullScreenLoading.module.css';

const FullScreenLoading: FC = () => (
  <div className={styles.loading} data-testid="loadingScreen">
    <LoadingSpinner />
  </div>
);

export default FullScreenLoading;
